var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAppContext } from '../contexts/AppContextProvider';
export var FormField = function (_a) {
    var field = _a.field, key = _a.key;
    var _b = useAppContext(), appConfig = _b.appConfig, setFormData = _b.setFormData;
    var _c = useState(appConfig.defaultPhonePrefix), phonePrefix = _c[0], setPhonePrefix = _c[1];
    var _d = useState(''), phoneNumber = _d[0], setPhoneNumber = _d[1];
    var handleChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        if (name !== 'phone-prefix' && name !== 'phone-number') {
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    useEffect(function () {
        var updateFormData = function () {
            var phone = "".concat(phonePrefix || '').concat(phoneNumber || '');
            setFormData(function (prevState) { return (__assign(__assign({}, prevState), { phone: phone })); });
        };
        updateFormData();
    }, [phonePrefix, phoneNumber]);
    var renderInput = function () {
        switch (field.type) {
            case 'textarea':
                return (_jsx("textarea", { rows: 4, cols: 50, name: field.name, placeholder: field.placeholder, onChange: handleChange }));
            case 'tel':
                return (_jsxs("div", __assign({ className: "phone-inputs" }, { children: [_jsx("input", { type: "text", name: "phone-prefix", value: phonePrefix, onChange: function (e) { return setPhonePrefix(e.target.value); } }), _jsx("input", { type: "text", name: "phone-number", placeholder: field.placeholder, value: phoneNumber, onChange: function (e) { return setPhoneNumber(e.target.value); } })] })));
            default:
                return (_jsx("input", { type: field.type, name: field.name, placeholder: field.placeholder, onChange: handleChange }));
        }
    };
    return (_jsx("div", __assign({ className: "form-field" }, { children: renderInput() }), key));
};
